import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Quote from './pages/Quote';
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import AdminProjects from './pages/admin/Projects';
import AdminContacts from './pages/admin/Contacts';
import AdminQuotes from './pages/admin/Quotes';
import AdminUsers from './pages/admin/Users';
import AdminProfile from './pages/admin/Profile';
import ProtectedRoute from './components/admin/ProtectedRoute';
import { adminAuthService } from './services/adminAuth';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    adminAuthService.initializeAuth();
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow pt-20">
                <Home />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/about" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow pt-20">
                <About />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/services" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow pt-20">
                <Services />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/projects" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow pt-20">
                <Projects />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/contact" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow pt-20">
                <Contact />
              </main>
              <Footer />
            </div>
          } />

          <Route path="/quote" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow pt-20">
                <Quote />
              </main>
              <Footer />
            </div>
          } />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/projects" element={
            <ProtectedRoute>
              <AdminProjects />
            </ProtectedRoute>
          } />
          <Route path="/admin/contacts" element={
            <ProtectedRoute>
              <AdminContacts />
            </ProtectedRoute>
          } />
          <Route path="/admin/quotes" element={
            <ProtectedRoute>
              <AdminQuotes />
            </ProtectedRoute>
          } />
          <Route path="/admin/users" element={
            <ProtectedRoute>
              <AdminUsers />
            </ProtectedRoute>
          } />
          <Route path="/admin/profile" element={
            <ProtectedRoute>
              <AdminProfile />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
